import StarOff from "./StarOff";

export * from "./AudioLines";
export * from "./BookAudio";
export * from "./BookHeadphones";
export * from "./BoomBox";
export * from "./Captions";
export * from "./CaptionsOff";
export * from "./CirclePause";
export * from "./CirclePlay";
export * from "./CircleStop";
export * from "./Clapperboard";
export * from "./DiamondMinus";
export * from "./DiamondPlus";
export * from "./Drama";
export * from "./Film";
export * from "./Guitar";
export * from "./Heart";
export * from "./HeartOff";
export * from "./Infinity";
export * from "./ListEnd";
export * from "./ListMinus";
export * from "./ListMusic";
export * from "./ListPlus";
export * from "./ListRestart";
export * from "./ListStart";
export * from "./ListVideo";
export * from "./ListX";
export * from "./Megaphone";
export * from "./MegaphoneOff";
export * from "./OctagonPause";
export * from "./Pause";
export * from "./PictureInPicture";
export * from "./PictureInPicture2";
export * from "./Podcast";
export * from "./Repeat1";
export * from "./StarHalf";
export * from "./StarOff";

export const Multimed = {
  StarOff,
};
